export interface BuildingItemGroup<T> {
    buildingKey: string;
    /** The building's name as the items carry it; undefined when none has one */
    buildingName?: string;
    items: T[];
}

/**
 * Groups an already sorted list by building for the board's "Byggnad" sort.
 * Groups are ordered by building name (Swedish collation, nameless last) so a
 * building keeps its place in every column; within a group the list's order
 * is kept.
 */
export function groupByBuildingName<T>(
    items: T[],
    getBuildingKey: (item: T) => string,
    getBuildingName: (item: T) => string | undefined
): BuildingItemGroup<T>[] {
    const groups = new Map<string, BuildingItemGroup<T>>();
    items.forEach(item => {
        const buildingKey = getBuildingKey(item);
        const group = groups.get(buildingKey);
        if (group) {
            group.items.push(item);
            if (!group.buildingName) group.buildingName = getBuildingName(item) || undefined;
        } else {
            groups.set(buildingKey, { buildingKey, buildingName: getBuildingName(item) || undefined, items: [item] });
        }
    });
    return Array.from(groups.values()).sort((a, b) => {
        if (!a.buildingName || !b.buildingName) {
            return Number(!a.buildingName) - Number(!b.buildingName);
        }
        return a.buildingName.localeCompare(b.buildingName, 'sv');
    });
}
